import React from 'react';
import { BiSolidLockOpen as LockIcon } from 'react-icons/bi';
import { BsGearWideConnected as GearIcon, BsLightningChargeFill as LightningIcon } from 'react-icons/bs';
import { FaClock as ClockIcon, FaWrench as WrenchIcon } from 'react-icons/fa';
import { MdSensorDoor as DoorIcon } from 'react-icons/md';
import { TiWeatherDownpour as RainIcon } from 'react-icons/ti';

import { Colors } from '../../utils/Colors';

import brochure from '../../assets/pdfDocuments/FR/pro/Brochure TECH-ROLL PRO.pdf';
import specification from '../../assets/pdfDocuments/FR/pro/Spécification TECH-ROLL PRO - INDOTECH.pdf';
import bottomBarImg from '../../assets/pictures/components/bottomBar.svg';
import brakesImg from '../../assets/pictures/components/brakes.svg';
import curtainImg from '../../assets/pictures/components/curtain.svg';
import endlocksImg from '../../assets/pictures/components/endlocks.svg';
import guidesImg from '../../assets/pictures/components/guides.svg';
import operatorImg from '../../assets/pictures/components/operator.svg';
import springsImg from '../../assets/pictures/components/springs.svg';
import windbarsImg from '../../assets/pictures/components/windbars.svg';

export const proPdfs = [
    { pdfTitle: 'products.pro.pdfs.brochure', pdfLink: { fr: brochure, en: brochure } },
    { pdfTitle: 'products.pro.pdfs.specification', pdfLink: { fr: specification, en: specification } },
];

export const proInfoKeys = [
    'products.pro.infos.motor',
    'products.pro.infos.cce',
    'products.pro.infos.curtain',
    'products.pro.infos.guides',
    'products.pro.infos.springs',
    'products.pro.infos.springless',
    'products.pro.infos.selfRepair',
    'products.pro.infos.bar',
    'products.pro.infos.safety',
];
export const proBenefits = [
    {
        benefitKey: 'products.pro.benefits.waterproof',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <RainIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.pro.benefits.speed',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <LightningIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.pro.benefits.costNoProduction',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <GearIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.pro.benefits.costRepair',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <WrenchIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.pro.benefits.maintenance',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <ClockIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.pro.benefits.impact',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <DoorIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
    {
        benefitKey: 'products.pro.benefits.security',
        icon: ({ size = 40, color = Colors.primary_blue, className = '' } = { size: 40, color: Colors.primary_blue, className: '' }) => (
            <LockIcon
                size={size}
                color={color}
                className={className}
            />
        ),
    },
];

export const proSpecificationKeys = [
    {
        label: 'specificationsLabel.cycles',
        value: 'products.pro.specificationsValues.cycles',
    },
    {
        label: 'specificationsLabel.drive_system',
        value: [
            {
                label: 'products.pro.specificationsValues.drive_system.chain_driven_operator',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.direct_drive_operator',
                value: 'specificationSecondValues.unavailable',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.integrated_brake_system',
                value: 'specificationSecondValues.solenoid',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.three_phase_208_to_575_volts',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.chain_hoist_for_manual_operation',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.torque_motor',
                value: 'specificationSecondValues.with_friction',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.mount_on_wall',
            },
            {
                label: 'products.pro.specificationsValues.drive_system.control_panel',
                value: 'specificationSecondValues.compact_system',
            },
        ],
    },
    {
        label: 'specificationsLabel.curtain',
        value: [
            {
                label: 'products.pro.specificationsValues.curtain.sbr',
                value: 'specificationSecondValues.standard_black',
            },
            {
                label: 'products.pro.specificationsValues.curtain.thickness',
                value: 'specificationSecondValues.blue_curtain_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.curtain_idler',
        value: 'products.pro.specificationsValues.curtain_idler',
    },
    {
        label: 'specificationsLabel.temperature',
        value: 'products.pro.specificationsValues.temperature',
    },
    {
        label: 'specificationsLabel.endlock_system',
        value: 'products.pro.specificationsValues.endlock_system',
    },
    {
        label: 'specificationsLabel.bottom_bar',
        value: 'products.pro.specificationsValues.bottom_bar',
    },
    {
        label: 'specificationsLabel.guide',
        value: 'products.pro.specificationsValues.guide',
    },
    {
        label: 'specificationsLabel.inertia_brake',
        value: 'products.pro.specificationsValues.inertia_brake',
    },
    {
        label: 'specificationsLabel.frame_color',
        value: [
            {
                label: 'products.pro.specificationsValues.frame_color.standard_yellow',
                value: 'specificationSecondValues.other_colors_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.safety',
        value: 'products.pro.specificationsValues.safety',
    },
    {
        label: 'specificationsLabel.mounting',
        value: [
            {
                label: 'products.pro.specificationsValues.mounting.concrete',
                value: 'products.pro.specificationsValues.mounting.steel',
            },
        ],
    },
    {
        label: 'specificationsLabel.balance_system',
        value: [
            {
                label: 'products.pro.specificationsValues.balance_system.springs',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.pro.specificationsValues.balance_system.counter_weight',
                value: 'specificationSecondValues.available_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.wind_bar',
        value: [
            {
                label: 'products.pro.specificationsValues.wind_bar.one',
                value: 'specificationSecondValues.available',
            },
            {
                label: 'products.pro.specificationsValues.wind_bar.two',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.pro.specificationsValues.wind_bar.external',
                value: 'specificationSecondValues.available_on_req',
            },
        ],
    },
    {
        label: 'specificationsLabel.options',
        value: [
            {
                label: 'products.pro.specificationsValues.options.windows',
                value: 'specificationSecondValues.available_on_req',
            },
            {
                label: 'products.pro.specificationsValues.options.pneumatic_sensor',
                value: 'specificationSecondValues.reversing_edges',
            },
            {
                label: 'products.pro.specificationsValues.options.reflective_stripes',
                value: 'specificationSecondValues.yellow_and_gray',
            },
            {
                label: 'products.pro.specificationsValues.options.photocells',
                value: 'specificationSecondValues.available',
            },
        ],
    },
    {
        label: 'specificationsLabel.other_electric',
        value: 'products.pro.specificationsValues.other_electric',
    },
    {
        label: 'specificationsLabel.wind_res',
        value: 'products.pro.specificationsValues.wind_res',
    },
];

export const proComponents = [
    {
        id: 'curtain',
        number: 1,
        title: 'products.pro.components.curtain.title',
        description: 'products.pro.components.curtain.description',
        img: curtainImg,
    },
    {
        id: 'endLocks',
        number: 2,
        title: 'products.pro.components.endLocks.title',
        description: 'products.pro.components.endLocks.description',
        img: endlocksImg,
    },
    {
        id: 'bottomBar',
        number: 3,
        title: 'products.pro.components.bottomBar.title',
        description: 'products.pro.components.bottomBar.description',
        img: bottomBarImg,
    },
    {
        id: 'guideRails',
        number: 4,
        title: 'products.pro.components.guideRails.title',
        description: 'products.pro.components.guideRails.description',
        img: guidesImg,
    },
    {
        id: 'windBars',
        number: 5,
        title: 'products.pro.components.windBars.title',
        description: 'products.pro.components.windBars.description',
        img: windbarsImg,
    },
    {
        id: 'springs',
        number: 6,
        title: 'products.pro.components.springs.title',
        description: 'products.pro.components.springs.description',
        img: springsImg,
    },
    {
        id: 'operators',
        number: 7,
        title: 'products.pro.components.operators.title',
        description: 'products.pro.components.operators.description',
        img: operatorImg,
    },
    {
        id: 'brakes',
        number: 8,
        title: 'products.pro.components.brakes.title',
        description: 'products.pro.components.brakes.description',
        img: brakesImg,
    },
];
